module.exports = __webpack_public_path__ + "fonts/microsoftYahei.2ec463e.ttf";